import { Async, toAsyncFetched } from '@client/new/helpers/types';
import { useSubscriptionBundlesModel } from '../model/subscriptionBundles.model';
import { BundlesCards, toBundleCards } from './subscriptionBundle.vm.mapper';
import { EditBundlePriceVM, useEditBundlePriceVM } from './editBundlePrice.vm';
import {
  EditBundleContentVM,
  useEditBundleContentVM,
} from './editBundleContent.vm';

export type BundlesVMData = {
  showSubscriptionBundles: boolean;
  cards: BundlesCards;
};

export type SubscriptionBundlesVM = BundlesVMData &
  Pick<
    EditBundlePriceVM,
    'confirmPriceModal' | 'priceEditModal' | 'confirmPriceDisableModal'
  > &
  Pick<EditBundleContentVM, 'list'>;

export const useSubscriptionBundlesVM = ({
  creatorId,
}: {
  creatorId: number;
}): Async<SubscriptionBundlesVM> => {
  const model = useSubscriptionBundlesModel({ creatorId });
  const {
    priceEditModal,
    confirmPriceModal,
    confirmPriceDisableModal,
    editBundlePrice,
    submittingBundleIds,
  } = useEditBundlePriceVM({
    model,
    creatorId,
  });
  const { list } = useEditBundleContentVM({ model });

  if (model.type !== 'fetched') return model;

  return toAsyncFetched<SubscriptionBundlesVM>({
    showSubscriptionBundles: model.value.hasBundleSubscriptions,
    cards: toBundleCards(
      model.value.initialSubscriptionBundles,
      editBundlePrice,
      submittingBundleIds,
    ),
    list,
    priceEditModal,
    confirmPriceModal,
    confirmPriceDisableModal,
  });
};
